import React from "react";
import { Link, useNavigate } from "react-router-dom";
import ProductPrice from "../product/ProductPrice";
import WishlistItem from "../Wishlist/WishlistItem";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Placeholder from "../Placeholders/Placeholder";
import useMobileDevice from "../../hooks/useMobileDevice";

function CatalogProduct({ product, saveProductsCb,updateWishlistProductStatus }) {
  const navigate = useNavigate();
  const { isMobile } = useMobileDevice();
  const onProductClick = (url) => {
    saveProductsCb().then(() => {
      return navigate(url);
    });
  };

  const updateWishlistProductStatuscb = (product_id,wishlist_status) => {
    updateWishlistProductStatus(product_id,wishlist_status);
  }

  return (
    <div className="col-md-4 col-6 product-margin-mb">
      <div className="product-box">
        <div
          className={`product-image mt-20 ${
            product?.available_for_order === "0" ? " sold-out" : ""
          }`}
        >
          <Link to={`/product/${product.url_path}`}>
          <div
            onClick={(e) => {
              e.preventDefault();
              onProductClick(`/product/${product.url_path}`);
            }}
            style={{ cursor: "pointer" }}
          >
            <LazyLoadImage
              alt={""}
              effect="blur"
              src={product.src}
              className="img-fluid d-block mx-auto"
              placeholder={<Placeholder variant="rectangle" height={isMobile ? "207px" : "312px"} />}
            />
          </div>
          {product?.available_for_order === "0" && (
            <div className="sold-out-text text-center">
              {product?.sold_out_heading || "SOLD OUT"}
            </div>
          )}
          </Link>
          
        </div>

        <WishlistItem
          productId={product?.id}
          isInWishlist={product?.is_in_wishlist}
          updateWishlistProductStatuscb = {updateWishlistProductStatuscb}
        />

        <div className="product-text mt-20">
        <Link to={`/product/${product.url_path}`}>
          <h3>
            {product.designer_name}
          </h3>
          <p className="desc truncate">{product.name}</p>
          <ProductPrice
            price={product.price}
            show_price={product.show_price?.toString() === "1"}
            discount_price={product?.deal_price ? product?.deal_price : product?.discount_price}
            discount_perc={product.discount_percentage}
            show_discount_price={
              product.show_discount_price?.toString() === "1"
            }
            show_discount_perc={true}
            layout={"2"}
          />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default CatalogProduct;
